import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'UiPanel',
  props: {
    noPadding: {
        type: Boolean,
        default: false,
    },
    rounded: {
        type: Boolean,
        default: true,
    },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["bg-gray-50 shadow ring-1 ring-gray-300", [__props.noPadding ? '' : 'p-4', __props.rounded ? 'rounded' : '']])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})